import { render, staticRenderFns } from "./mktDraggableFile.vue?vue&type=template&id=5a771720&"
import script from "./mktDraggableFile.vue?vue&type=script&lang=js&"
export * from "./mktDraggableFile.vue?vue&type=script&lang=js&"
import style0 from "./mktDraggableFile.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports